import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { TextField, TextFieldSkeleton } from 'components/shared/TextField/TextField';
import type { IntlKey } from 'locales';

type LabelledTextFieldProps = {
  id: string;
  labelKey?: IntlKey;
  value?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isLoading: boolean;
};

export function LabelledTextField({ value, id, isDisabled, isReadOnly, isLoading, labelKey }: LabelledTextFieldProps) {
  return (
    <BlockOrientationFormGroup inputId={id} label={labelKey}>
      {isLoading && !value ? (
        <TextFieldSkeleton />
      ) : (
        <TextField id={id} value={value} isReadOnly={isReadOnly} isDisabled={isDisabled} />
      )}
    </BlockOrientationFormGroup>
  );
}

LabelledTextField.displayName = 'FileCode';
